/* LOOM PDP (Dore-structuur): variantkeuze, galerij per kleur (hoofdbeeld + pijlen + thumbs, ronde 2 19 sep), per-paarprijs, lightbox, coming-soon swatches, add-to-cart via de bestaande drawer-hook. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.lpdReady) return;
    root.dataset.lpdReady = '1';
    var dataEl = root.parentElement.querySelector('script[data-lpd-data]') || document.querySelector('script[data-lpd-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var byKey = {};
    data.variants.forEach(function (v) { byKey[v.key] = v; });
    var selected = data.selected.slice();
    var busy = false;

    var q = function (s) { return root.querySelector(s); };
    var priceEl = q('[data-lpd-price]'), ppEl = q('[data-lpd-pp]');
    /* Ronde 3 (19 sep): doorgestreepte compare_at en packvoordeel-label naast de prijs; percentage = floor((compareAt - price) * 100 / compareAt). */
    var wasEl = q('[data-lpd-was]'), pctEl = q('[data-lpd-pct]');
    function pctOf(v) { var c = v && v.compareAt ? v.compareAt : 0; return c > v.price ? Math.floor((c - v.price) * 100 / c) : 0; }
    var atc = q('[data-lpd-atc]'), atcLabel = q('[data-lpd-atc-label]'), atcPrice = q('[data-lpd-atc-price]'), atcError = q('[data-lpd-atc-error]');
    var atcSticky = q('[data-lpd-atc-sticky]'), stickyLabel = q('[data-lpd-atc-label-sticky]'), stickyPrice = q('[data-lpd-atc-price-sticky]'), stickySel = q('[data-lpd-sticky-sel]');
    var stickyBar = q('[data-lpd-sticky-bar]');
    var stock = q('[data-lpd-stock]');
    var colorName = q('[data-lpd-color-name]'), sizeName = q('[data-lpd-size-name]'), packName = q('[data-lpd-pack-name]');
    var track = q('[data-lpd-track]'), thumbs = q('[data-lpd-thumbs]'), stage = q('[data-lpd-stage]');
    var navPrev = q('[data-lpd-prev]'), navNext = q('[data-lpd-next]');

    function fmt(cents) { return '\u20ac' + (cents / 100).toFixed(2).replace('.', ','); }
    function packCount(value) { var m = String(value || '').match(/\d+/); return m ? parseInt(m[0], 10) : 1; }
    function current() { return byKey[selected.join('|')] || null; }

    /* Galerij (Dore Deep Sleep Mask-patroon): een zichtbare set per kleur; binnen de set een snap-track met een beeld per slide,
       prev/next-pijlen in het beeld, thumbrij eronder. Index = afgeleid van scrollLeft, dus swipe, pijl en thumb blijven synchroon. */
    function activeSet() { return track ? track.querySelector('.lpd-set:not([hidden])') : null; }
    function setCount(set) { return set ? set.querySelectorAll('.lpd-media').length : 0; }
    function setIndex(set) { return set ? Math.round(set.scrollLeft / Math.max(1, set.clientWidth)) : 0; }
    function goTo(i, instant) {
      var set = activeSet(); if (!set) return;
      var n = setCount(set); if (!n) return;
      var idx = ((i % n) + n) % n;
      var img = set.querySelectorAll('.lpd-media img')[idx]; if (img && img.loading === 'lazy') img.loading = 'eager';
      set.scrollTo({ left: idx * set.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      markThumb(idx);
    }
    function markThumb(idx) {
      if (!thumbs) return;
      Array.prototype.forEach.call(thumbs.children, function (b, i) {
        var on = i === idx;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) {
          var l = b.offsetLeft, r = l + b.offsetWidth;
          if (l < thumbs.scrollLeft) thumbs.scrollTo({ left: l, behavior: 'smooth' });
          else if (r > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: r - thumbs.clientWidth, behavior: 'smooth' });
        }
      });
    }
    function buildThumbs() {
      if (!thumbs) return;
      var set = activeSet();
      thumbs.replaceChildren();
      if (stage) stage.setAttribute('data-lpd-count', String(setCount(set)));
      if (!set) return;
      var figs = Array.prototype.slice.call(set.querySelectorAll('.lpd-media'));
      figs.forEach(function (fig, i) {
        var img = fig.querySelector('img');
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'lpd-thumb'; b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', 'Beeld ' + (i + 1) + ' van ' + figs.length);
        var t = document.createElement('img'); t.src = img.currentSrc || img.src; t.alt = ''; t.loading = 'lazy'; t.width = 60; t.height = 60;
        b.appendChild(t);
        b.addEventListener('click', function () { goTo(i); });
        thumbs.appendChild(b);
      });
      if (!set.dataset.lpdScroll) {
        set.dataset.lpdScroll = '1';
        var raf = 0;
        set.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () { if (set === activeSet()) markThumb(setIndex(set)); });
        }, { passive: true });
      }
    }
    if (navPrev) navPrev.addEventListener('click', function () { goTo(setIndex(activeSet()) - 1); });
    if (navNext) navNext.addEventListener('click', function () { goTo(setIndex(activeSet()) + 1); });
    if (stage) stage.addEventListener('keydown', function (e) {
      if (e.target.closest('.lpd-media')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(setIndex(activeSet()) + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(setIndex(activeSet()) - 1); }
    });
    window.addEventListener('resize', function () { var s = activeSet(); if (s) s.scrollLeft = setIndex(s) * s.clientWidth; });
    function showColor(color) {
      if (!track) return;
      var sets = track.querySelectorAll('.lpd-set');
      var found = false;
      Array.prototype.forEach.call(sets, function (s) {
        var on = s.getAttribute('data-lpd-set') === color;
        if (on) found = true;
        if (on) { s.removeAttribute('hidden'); s.querySelectorAll('img[loading=lazy]').forEach(function (img, i) { if (i < 2) img.loading = 'eager'; }); s.scrollLeft = 0; }
        else s.setAttribute('hidden', '');
      });
      if (!found && sets[0]) sets[0].removeAttribute('hidden');
      buildThumbs();
    }

    function updateUrl(v) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }

    function render() {
      var v = current();
      if (colorName && data.colorIndex > -1) colorName.textContent = selected[data.colorIndex];
      if (sizeName && data.sizeIndex > -1) sizeName.textContent = selected[data.sizeIndex];
      if (packName && data.packIndex > -1) packName.textContent = packCount(selected[data.packIndex]) + ' paar';
      var n = data.packIndex > -1 ? packCount(selected[data.packIndex]) : 1;
      if (v) {
        priceEl.textContent = fmt(v.price);
        if (ppEl) ppEl.textContent = data.packIndex > -1 ? (fmt(Math.round(v.price / n)) + ' per paar') : '';
        var pct = pctOf(v);
        if (wasEl) wasEl.textContent = pct > 0 ? fmt(v.compareAt) : '';
        if (pctEl) pctEl.textContent = pct > 0 ? ('-' + pct + '%') : '';
        atc.setAttribute('data-variant-id', v.id);
        var ok = v.available;
        atc.disabled = !ok || busy; if (atcSticky) atcSticky.disabled = !ok || busy;
        atcLabel.textContent = ok ? 'Add to cart' : 'Uitverkocht'; if (stickyLabel) stickyLabel.textContent = atcLabel.textContent;
        atcPrice.textContent = fmt(v.price); if (stickyPrice) stickyPrice.textContent = fmt(v.price);
        if (stickySel) stickySel.textContent = v.title;
        if (stock) { stock.setAttribute('data-state', ok ? 'in' : 'out'); stock.querySelector('span').textContent = ok ? 'Op voorraad' : 'Uitverkocht'; }
        updateUrl(v);
      } else {
        if (ppEl) ppEl.textContent = '';
        if (wasEl) wasEl.textContent = ''; if (pctEl) pctEl.textContent = '';
        atc.disabled = true; if (atcSticky) atcSticky.disabled = true;
        atcLabel.textContent = 'Niet beschikbaar'; if (stickyLabel) stickyLabel.textContent = 'Niet beschikbaar';
        if (stock) { stock.setAttribute('data-state', 'out'); stock.querySelector('span').textContent = 'Niet beschikbaar'; }
      }
    }

    root.querySelectorAll('[data-lpd-option]').forEach(function (wrap) {
      var idx = parseInt(wrap.getAttribute('data-lpd-option'), 10);
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lpd-value]');
        if (!btn || !wrap.contains(btn)) return;
        var value = btn.getAttribute('data-lpd-value');
        if (idx === data.colorIndex && data.launchColors.indexOf(value) === -1) return;
        selected[idx] = value;
        wrap.querySelectorAll('[data-lpd-value]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (idx === data.colorIndex) showColor(value);
        render();
      });
    });


    /* Coming-soon swatches (Mosterd, Lila): niet selecteerbaar, klik toont de tag "Coming soon" bij de swatch. */
    var soonTimer = 0;
    root.querySelectorAll('[data-lpd-soon]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        root.querySelectorAll('.lpd-swatch-wrap[data-open]').forEach(function (w) { w.removeAttribute('data-open'); });
        var wrap = btn.closest('.lpd-swatch-wrap');
        if (wrap) wrap.setAttribute('data-open', '1');
        clearTimeout(soonTimer);
        soonTimer = setTimeout(function () { if (wrap) wrap.removeAttribute('data-open'); }, 2600);
      });
    });

    /* Lightbox: klik op een galerijbeeld, vorige/volgende, sluiten, Esc, pijltoetsen, swipe. */
    var lb = q('[data-lpd-lightbox]');
    if (lb && track) {
      var lbImg = lb.querySelector('[data-lpd-lb-img]'), lbCount = lb.querySelector('[data-lpd-lb-count]');
      var lbPrev = lb.querySelector('[data-lpd-lb-prev]'), lbNext = lb.querySelector('[data-lpd-lb-next]'), lbClose = lb.querySelector('[data-lpd-lb-close]');
      var lbItems = [], lbIndex = 0, lbOpener = null, scrollEl = null, scrollTop = 0;
      function lbShow(i) {
        if (!lbItems.length) return;
        lbIndex = (i + lbItems.length) % lbItems.length;
        var src = lbItems[lbIndex];
        lbImg.src = src.currentSrc || src.src; lbImg.alt = src.alt || '';
        lbCount.textContent = (lbIndex + 1) + ' / ' + lbItems.length;
        lbPrev.disabled = lbNext.disabled = lbItems.length < 2;
      }
      function lbOpen(i, opener) {
        var set = activeSet(); if (!set) return;
        lbItems = Array.prototype.slice.call(set.querySelectorAll('.lpd-media img'));
        lbOpener = opener || null;
        scrollEl = document.scrollingElement || document.documentElement;
        lb.removeAttribute('hidden'); lb.setAttribute('data-open', '1');
        document.documentElement.setAttribute('data-lpd-lb-open', '1');
        lbShow(i);
        lbClose.focus();
      }
      function lbHide() {
        lb.setAttribute('hidden', ''); lb.removeAttribute('data-open');
        document.documentElement.removeAttribute('data-lpd-lb-open');
        lbImg.removeAttribute('src');
        if (lbOpener && lbOpener.focus) lbOpener.focus();
      }
      track.addEventListener('click', function (e) {
        var fig = e.target.closest('.lpd-media');
        if (!fig || !track.contains(fig)) return;
        var set = activeSet(); if (!set || !set.contains(fig)) return;
        var figs = Array.prototype.slice.call(set.querySelectorAll('.lpd-media'));
        lbOpen(figs.indexOf(fig), fig);
      });
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var fig = e.target.closest('.lpd-media'); if (!fig) return;
        e.preventDefault(); fig.click();
      });
      lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
      lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
      lbClose.addEventListener('click', lbHide);
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-lpd-lb-stage')) lbHide(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.hasAttribute('data-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); lbHide(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbIndex + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbIndex - 1); }
        else if (e.key === 'Tab') {
          var f = [lbClose, lbPrev, lbNext].filter(function (b) { return !b.disabled; });
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      var tx = null, ty = null;
      lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = ty = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) lbShow(dx < 0 ? lbIndex + 1 : lbIndex - 1);
      }, { passive: true });
      root.querySelectorAll('.lpd-media').forEach(function (fig) { fig.setAttribute('tabindex', '0'); fig.setAttribute('role', 'button'); fig.setAttribute('aria-label', 'Vergroot beeld'); });
    }

    function addToCart(trigger) {
      var v = current();
      if (!v || !v.available || busy) return;
      busy = true; atcError.textContent = '';
      atc.setAttribute('aria-busy', 'true'); atc.disabled = true; if (atcSticky) atcSticky.disabled = true;
      var prev = atcLabel.textContent; atcLabel.textContent = 'Toevoegen'; if (stickyLabel) stickyLabel.textContent = 'Toevoegen';
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Toevoegen is niet gelukt.'); return j; }); })
        .then(function () {
          busy = false; atc.removeAttribute('aria-busy'); atcLabel.textContent = prev; if (stickyLabel) stickyLabel.textContent = prev; render();
          if (document.getElementById('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('loom:cart-added', { detail: { opener: trigger || atc } }));
          } else {
            window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart');
          }
        })
        .catch(function (err) {
          busy = false; atc.removeAttribute('aria-busy'); atcLabel.textContent = prev; if (stickyLabel) stickyLabel.textContent = prev; render();
          atcError.textContent = err && err.message === 'Failed to fetch' ? 'Verbinding onderbroken. Controleer je winkelwagen voordat je opnieuw toevoegt.' : (err && err.message) || 'Toevoegen is niet gelukt.';
        });
    }
    atc.addEventListener('click', function () { addToCart(atc); });
    if (atcSticky) atcSticky.addEventListener('click', function () { addToCart(atcSticky); });

    if (stickyBar && 'IntersectionObserver' in window) {
      stickyBar.removeAttribute('hidden');
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0;
        stickyBar.setAttribute('data-visible', (!e.isIntersecting && below) ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(atc);
    }

    buildThumbs();
    render();
  }
  function boot() { document.querySelectorAll('[data-lpd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
